/* Shared between `List.js` (its status column, via `statusColumn`) and `ReturnDetail.js` so the two
   screens can't drift apart on how a status renders — same icon, same tone, wherever a return's
   status is shown. Mirrors `orders/parts.js`'s own `STATUS_ICON`, but returns have their own
   status set — `sent_to_logistics`, not `sent_for_delivering` — so this is not the same map. */

import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, SyncOutlined, TruckOutlined } from "@ant-design/icons";

export const STATUS_ICON = {
  new: { Icon: ClockCircleOutlined, tone: "wait" },
  processing: { Icon: SyncOutlined, tone: "wait" },
  sent_to_logistics: { Icon: TruckOutlined, tone: "wait" },
  closed: { Icon: CheckCircleOutlined, tone: "ok" },
  canceled: { Icon: CloseCircleOutlined, tone: "no" },
};
